import { connect } from "react-redux";
import { Creators, getEditQueueItem } from "../../reducer";
import QueueItemDrawer from "./QueueItemDrawer";

export default connect(
  state => ({
    editQueueItem: getEditQueueItem(state)
  }),
  dispatch => ({
    onCompleteEditQueueItem: () => dispatch(Creators.completeEditQueueItem())
  })
)(QueueItemDrawer);



// WEBPACK FOOTER //
// ./src/staff/components/QueueItemDrawer/index.js